import React from 'react';

export default function PoliticasQualidadePage() {
  return (
    <div>
      Qualidade - Políticas de Qualidade (placeholder).
    </div>
  );
}

